import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { roundHalfUp } from '@/utils/commonUtil'
import moment from 'moment'

// 按照HsCode分组
function toGroupByHsCode(cargoList) {
  const result = []
  if (cargoList.length > 0) {
    /* 设置分组后的编号 */
    const noMap = new Map()
    for (const cargo of cargoList) {
      let no = noMap.get(cargo.hsCode)
      if (!no) {
        no = noMap.size + 1
        noMap.set(cargo.hsCode, no)
      }
      cargo.no = no
    }
    cargoList.sort((a, b) => a.no - b.no)
    let groupItem = cargoList[0]
    for (let i = 1; i < cargoList.length; ++i) {
      const item = cargoList[i]
      if (item.hsCode === groupItem.hsCode) {
        groupItem.packageNumber += item.packageNumber
        groupItem.originNetWeight += item.originNetWeight
        groupItem.netWeight += item.netWeight
        groupItem.originGrossWeight += item.originGrossWeight
        groupItem.grossWeight += item.grossWeight
        groupItem.volume += item.volume
        groupItem.goodsNumber += item.goodsNumber
        groupItem.totalProductPrice += item.totalProductPrice
      } else {
        result.push(groupItem)
        groupItem = { ...item }
      }
    }
    result.push(groupItem)
  }
  return result
}

// 统计
export function toStatistics(rows, usCommodityCodeList, usCustomsClearance, lob) {
  const contain499 = usCustomsClearance.countryOfOrigin !== 'BU' && usCustomsClearance.countryOfOrigin !== 'KH'
  const contain501 = lob !== 'AE' && lob !== 'AI'

  const usCommodityCodeMap = new Map()
  for (const item of usCommodityCodeList) {
    usCommodityCodeMap.set(item.code, item)
  }

  let cargoList = []
  for (const row of rows) {
    const cargo = {
      customsClearanceProductName: row.customsClearanceProductName,
      packageNumber: Number(row.packageNumber),
      originNetWeight: Number(row.netWeight),
      netWeight: Number(row.netWeight),
      originGrossWeight: Number(row.grossWeight),
      grossWeight: Number(row.grossWeight),
      volume: Number(row.volume),
      goodsNumber: Number(row.goodsNumber),
      totalProductPrice: Number(row.totalProductPrice),
      chinaAdditionalRate: Number(row.chinaAdditionalRate)
    }
    const usCommodityCode = usCommodityCodeMap.get(cargo.customsClearanceProductName)
    if (!usCommodityCode) {
      continue
    }
    cargo.hsCode = usCommodityCode.hsCode
    cargo.customsRate = usCommodityCode.customsRate
    cargo.customsRateAmount = usCommodityCode.customsRateAmount
    cargo.additionalRate056 = usCommodityCode.additionalRate056
    cargo.containAdditionalTax499 = usCommodityCode.containAdditionalTax499
    cargo.containAdditionalTax501 = usCommodityCode.containAdditionalTax501
    cargo.chinaHongKongAdditionalTaxRule = usCommodityCode.chinaHongKongAdditionalTaxRule
    cargoList.push(cargo)
  }
  if (usCustomsClearance.generatingFileMergeSameProduct) {
    cargoList = toGroupByHsCode(cargoList)
  }

  const chargeItem499 = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', '499')
  const chargeItem501 = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', '501')
  for (const item of cargoList) {
    /* 取整 */
    item.netWeight = Math.round(item.netWeight)
    item.grossWeight = Math.round(item.grossWeight)
    item.totalProductPrice = Math.round(item.totalProductPrice)
    const tariff = item.totalProductPrice * item.customsRate / 100 + item.netWeight * item.customsRateAmount
    item.tariff = roundHalfUp(tariff, 2)
    item.chinaAdditionalRateAmount = item.chinaAdditionalRate * item.totalProductPrice / 100
    item.chinaAdditionalRateAmount = roundHalfUp(item.chinaAdditionalRateAmount, 2)
    item.additionalRate056Amount = item.additionalRate056 * item.netWeight
    item.additionalRate056Amount = roundHalfUp(item.additionalRate056Amount, 2)
    if (!contain499) {
      item.containAdditionalTax499 = false
    }
    if (item.containAdditionalTax499 && chargeItem499) {
      item.rate499 = chargeItem499.defaultApRate * 100
      item.rate499 = roundHalfUp(item.rate499, 4)
      item.rate499Amount = item.rate499 * item.totalProductPrice / 100
      item.rate499Amount = roundHalfUp(item.rate499Amount, 2)
    } else {
      item.rate499 = 0
      item.rate499Amount = 0
    }
    if (!contain501) {
      item.containAdditionalTax501 = false
    }
    if (item.containAdditionalTax501 && chargeItem501) {
      item.rate501 = chargeItem501.defaultApRate * 100
      item.rate501 = roundHalfUp(item.rate501, 4)
      item.rate501Amount = item.rate501 * item.totalProductPrice / 100
      item.rate501Amount = roundHalfUp(item.rate501Amount, 2)
    } else {
      item.rate501 = 0
      item.rate501Amount = 0
    }
    if (item.chinaHongKongAdditionalTaxRule) {
      const chargeItemHk = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', item.chinaHongKongAdditionalTaxRule)
      // 中国香港税则
      item.chinaHkAdditionalRate = chargeItemHk.defaultApRate * 100
      item.chinaHkAdditionalRate = roundHalfUp(item.chinaHkAdditionalRate, 4)
      item.chinaHkAdditionalRateAmount = item.chinaHkAdditionalRate * item.totalProductPrice / 100
      item.chinaHkAdditionalRateAmount = roundHalfUp(item.chinaHkAdditionalRateAmount, 2)
    } else {
      item.chinaHkAdditionalRate = 0
      item.chinaHkAdditionalRateAmount = 0
    }
  }

  /* 合计 */
  usCustomsClearance.totalPack = 0
  usCustomsClearance.totalNetWeight = 0
  usCustomsClearance.totalGrossWeight = 0
  usCustomsClearance.totalVolume = 0
  usCustomsClearance.totalNumber = 0
  usCustomsClearance.totalCargoValue = 0
  usCustomsClearance.totalTariff = 0
  usCustomsClearance.totalFee056 = 0
  usCustomsClearance.totalFee499 = 0
  usCustomsClearance.totalFee501 = 0
  usCustomsClearance.totalChinaAdditionalRate = 0
  for (const item of cargoList) {
    usCustomsClearance.totalPack += item.packageNumber
    usCustomsClearance.totalNetWeight += item.originNetWeight
    usCustomsClearance.totalGrossWeight += item.originGrossWeight
    usCustomsClearance.totalVolume += item.volume
    usCustomsClearance.totalNumber += item.goodsNumber
    usCustomsClearance.totalCargoValue += item.totalProductPrice
    usCustomsClearance.totalTariff += item.tariff
    if (usCustomsClearance.showChinaSurtax) {
      usCustomsClearance.totalTariff += item.chinaAdditionalRateAmount
      usCustomsClearance.totalTariff += item.chinaHkAdditionalRateAmount
    }
    usCustomsClearance.totalFee056 += item.additionalRate056Amount
    usCustomsClearance.totalFee499 += item.rate499Amount
    usCustomsClearance.totalFee501 += item.rate501Amount
    usCustomsClearance.totalChinaAdditionalRate += item.chinaAdditionalRateAmount
  }
  /* 499最大、最小值验证 */
  if (chargeItem499 && usCustomsClearance.totalFee499 > 0) {
    if (usCustomsClearance.totalFee499 < chargeItem499.apAmountIntervalMin) {
      usCustomsClearance.totalFee499 = roundHalfUp(chargeItem499.apAmountIntervalMin, 2)
    } else if (usCustomsClearance.totalFee499 > chargeItem499.apAmountIntervalMax) {
      usCustomsClearance.totalFee499 = roundHalfUp(chargeItem499.apAmountIntervalMax, 2)
    }
  }
  usCustomsClearance.otherTotalCharge = usCustomsClearance.totalFee056 + usCustomsClearance.totalFee499 + usCustomsClearance.totalFee501
  usCustomsClearance.total = usCustomsClearance.totalTariff + usCustomsClearance.otherTotalCharge
  usCustomsClearance.totalNetWeight = roundHalfUp(usCustomsClearance.totalNetWeight, 4)
  usCustomsClearance.totalGrossWeight = roundHalfUp(usCustomsClearance.totalGrossWeight, 4)
  usCustomsClearance.totalVolume = roundHalfUp(usCustomsClearance.totalVolume, 3)
  usCustomsClearance.totalTariff = roundHalfUp(usCustomsClearance.totalTariff, 2)
  usCustomsClearance.totalFee056 = roundHalfUp(usCustomsClearance.totalFee056, 2)
  usCustomsClearance.totalFee499 = roundHalfUp(usCustomsClearance.totalFee499, 2)
  usCustomsClearance.totalFee501 = roundHalfUp(usCustomsClearance.totalFee501, 2)
  usCustomsClearance.totalChinaAdditionalRate = roundHalfUp(usCustomsClearance.totalChinaAdditionalRate, 2)
  usCustomsClearance.otherTotalCharge = roundHalfUp(usCustomsClearance.otherTotalCharge, 2)
  usCustomsClearance.total = roundHalfUp(usCustomsClearance.total, 2)
}

// 同步ata信息
export function syncAtaInfo(usCustomsClearanceList, ata) {
  for (const item of usCustomsClearanceList) {
    item.importDate = ata
    if (item.importDate) {
      item.entryDate = moment(item.importDate).subtract(2, 'days').format('YYYY-MM-DD')
      item.summaryDate = moment(item.entryDate).add(10, 'days').format('YYYY-MM-DD')
    }
  }
}

// 同步atd信息
export function syncAtdInfo(usCustomsClearanceList, atd) {
  for (const item of usCustomsClearanceList) {
    item.exportDate = atd
  }
}

// 同步atd信息
export function syncAtdInfoAE(usCustomsClearanceList, atd) {
  for (const item of usCustomsClearanceList) {
    item.importDate = atd
    item.entryDate = atd
    if (item.entryDate) {
      item.summaryDate = moment(item.entryDate).add(10, 'days').format('YYYY-MM-DD')
    }
    item.exportDate = atd
  }
}
